export const CHANNEL_NAME = "mycawanBackoffice";

export type BroadcastAction =
  | Logout
  | BackendDataRefreshed
  | FrontendStateUpdated;

export interface Logout {
  action: "logout";
}

export interface BackendDataRefreshed {
  action: "backendDataRefreshed";
  payload: object;
}

export interface FrontendStateUpdated {
  action: "frontendStateUpdated";
}
